import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { routes } from './routes'

import { PrivateWrapper } from './PrivateWrapper'
import { Login } from './Login'
import { ActionsList } from 'pages/Actions/Actions'
import 'react-toastify/dist/ReactToastify.css'
import { Header } from '../components/Header/Header'

export const Router = () => {
  const location = useLocation()
  return (
    <AppWrapper>
      <PageWrapper>
        {/*{location.pathname !== routes.Login && <Header />}*/}

        <Routes>
          <Route
            path={routes.Actions}
            element={
              <PrivateWrapper>
                <ActionsList />
              </PrivateWrapper>
            }
          />
          <Route path={routes.Login} element={<Login />} />
          <Route path="*" element={<Navigate to={routes.Login} />} />
        </Routes>
      </PageWrapper>
    </AppWrapper>
  )
}

const AppWrapper = styled.div`
  width: 100%;
  height: 100%;
`
const PageWrapper = styled.div`
  margin: 0;
`
